import { municipios } from "../data/municipios";



export const getMunByStartsWith = ( char = '' ) => {

  char = char.toLocaleLowerCase().trim();
  
  if( char.length === 0 ) return [];

  return municipios.filter(
    municipio => municipio.id.startsWith(char)
  );

}